"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TooltipInner = exports.TooltipContainer = void 0;
var _styledComponents = _interopRequireWildcard(require("styled-components"));
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function (e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (const t in e) "default" !== t && {}.hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]); return f; })(e, t); }
const tooltipTopStyles = active => `
  transform: ${active ? 'scale(1) translateX(-50%) translateY(-100%)' : 'scale(0) translateX(-50%) translateY(-100%)'};
`;
const tooltipLeftStyles = active => `
  transform: ${active ? 'scale(1) translateX(-100%) translateY(-50%)' : 'scale(0) translateX(-100%) translateY(-50%)'};
`;
const tooltipRightStyles = active => `
  transform: ${active ? 'scale(1) translateX(0) translateY(-50%)' : 'scale(0) translateX(0) translateY(-50%)'};
`;
const tooltipBottomStyles = active => `
  transform: ${active ? 'scale(1) translateX(-50%)' : 'scale(0) translateX(-50%)'};
`;
const defaultTooltip = theme => `
  background: ${theme.colors.tooltip.default};
  color: ${theme.colors.tooltip.defaultText};

  &::after {
    border-color: ${theme.colors.tooltip.default};
  }
`;
const errorTooltip = theme => `
  background: ${theme.colors.tooltip.error};
  color: ${theme.colors.tooltip.errorText};

  &::after {
    border-color: ${theme.colors.tooltip.error};
  }
`;
const warningTooltip = theme => `
  background: ${theme.colors.tooltip.warning};
  color: ${theme.colors.tooltip.warningText};

  &::after {
    border-color: ${theme.colors.tooltip.warning};
  }
`;
const infoTooltip = theme => `
  background: ${theme.colors.tooltip.info};
  color: ${theme.colors.tooltip.infoText};

  &::after {
    border-color: ${theme.colors.tooltip.info};
  }
`;
const TooltipInner = exports.TooltipInner = _styledComponents.default.span.withConfig({
  displayName: "styles__TooltipInner",
  componentId: "sc-19gof3x-0"
})(["display:block;font-family:", ";font-weight:", ";font-size:", ";line-height:", ";letter-spacing:", ";padding:", ";border-radius:", ";position:relative;box-shadow:", ";&::after{position:absolute;content:'';display:inline-block;width:0;height:0;border-style:solid;}", ";"], ({
  theme
}) => theme.tooltip.fontFamily, ({
  theme
}) => theme.tooltip.fontWeight, ({
  theme
}) => theme.tooltip.fontSize, ({
  theme
}) => theme.tooltip.lineHeight, ({
  theme
}) => theme.tooltip.letterSpacing, ({
  theme
}) => theme.tooltip.padding, ({
  theme
}) => theme.tooltip.borderRadius, ({
  theme
}) => theme.tooltip.shadow, ({
  type,
  theme
}) => {
  if (type === 'error') {
    return errorTooltip(theme);
  }
  if (type === 'warning') {
    return warningTooltip(theme);
  }
  if (type === 'info') {
    return infoTooltip(theme);
  }
  return defaultTooltip(theme);
});
const TooltipContainer = exports.TooltipContainer = _styledComponents.default.span.withConfig({
  displayName: "styles__TooltipContainer",
  componentId: "sc-19gof3x-1"
})(["position:absolute;z-index:400;display:block;max-width:17rem;text-align:center;text-transform:none;pointer-events:none;transition:cubic-bezier(0.4,0,0.2,1) 200ms transform;transform-origin:top left;overflow-wrap:break-word;", ";", "}"], ({
  active,
  position
}) => {
  if (position === 'top') {
    return `
        ${tooltipTopStyles(active)}
        ${TooltipInner} {
          bottom: 5px;

          &::after {
            left: 50%;
            right: auto;
            transform: translateX(-50%);
            bottom: -5px;
            border-width: 5px 5px 0 5px;
            border-right-color: transparent;
            border-bottom-color: transparent;
            border-left-color: transparent;
          }
        }
      `;
  }
  if (position === 'left') {
    return `
        ${tooltipLeftStyles(active)}
        ${TooltipInner} {
          right: 5px;

          &::after {
            top: calc(50% - 5px);
            right: -4px;
            border-width: 5px 0 5px 5px;
            border-top-color: transparent;
            border-right-color: transparent;
            border-bottom-color: transparent;
          }
        }
      `;
  }
  if (position === 'right') {
    return `
        ${tooltipRightStyles(active)}
        ${TooltipInner} {
          left: 5px;

          &::after {
            left: 50%;
            right: auto;
            transform: translateX(-50%);
            left: -2px;
            top: calc(50% - 5px);
            border-width: 5px 5px 5px 0;
            border-top-color: transparent;
            border-bottom-color: transparent;
            border-left-color: transparent;
          }
        }
      `;
  }
  return `
      ${tooltipBottomStyles(active)}
      ${TooltipInner} {
        top: 5px;

        &::after {
          left: 50%;
          right: auto;
          transform: translateX(-50%);
          top: -5px;
          border-width: 0 5px 5px 5px;
          border-top-color: transparent;
          border-right-color: transparent;
          border-left-color: transparent;
        }
      }
    `;
}, ({
  tooltipContainerStyles,
  tooltipInnerStyles
}) => (0, _styledComponents.css)(["", " ", "{", "}"], tooltipContainerStyles, TooltipInner, tooltipInnerStyles));